import axios from 'axios';
import { toast } from 'react-toastify';
import { API_BASE_URL } from 'store/constant';

import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import { format } from 'date-fns';


// axios instance for making requests 
const axiosInstance = axios.create();

// axios instance base url
axiosInstance.defaults.withCredentials = true;
axiosInstance.defaults.baseURL = API_BASE_URL;

// request interceptor 
axiosInstance.interceptors.request.use((config) => {
    //config.headers['Authorization'] = localStorage.getItem('token');

    const transformDates = (obj) => {
        if (!obj || typeof obj !== 'object') return obj;

        Object.keys(obj).forEach(key => {
            const value = obj[key];

            if (value instanceof Date) {
                obj[key] = format(value, 'yyyy-MM-dd');
            } else if (typeof value === 'object') {
                transformDates(value);
            }
        });

        return obj;
    };

    config.data = transformDates(config.data);


    return config;
});

// response interceptor
let counter = 0;
axiosInstance.interceptors.response.use(
    (response) => {

        if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
            return response; // return full response
        }

        return response.data;
    },
    (error) => {

        // console.log('Error:', error, error.config);
        counter++;
        //Connections refuse 
        if (!error.status) {
            //If error message contain 404 not found ,than no need to re-process
            if ((error.message).includes('404')) {

                return Promise.reject({ 'status': 404, 'statusText': 'ERROR', 'message': '404 Not found!' });

            } else if (counter == 0) { // @todo:: change the condition to 5 once understand these code
                return axiosInstance.request(error.config);

            } else if (error.response.status === 401) {

                const textMessage = error.response.data.status === 'failed' ? error.response.data.message : 'Your session has expired. Please login again.';
                const titleMessage = error.response.data.status === 'failed' ? 'Session Expired' : 'Session Timed Out';
                // return axiosInstance.request(error.config);
                const loginType = localStorage.getItem('login_type');

                const redirectMap = {
                    client: '/',
                    admin: '/admin',
                    dashboard_admin: '/pm-dashboard-login',
                }

                const redirectUrl = redirectMap[loginType] || '/'

                return Swal.fire({
                    icon: 'warning',
                    title: titleMessage,
                    text: textMessage,
                    confirmButtonText: 'Login again'
                }).then(() => {
                    
                    setTimeout(() => {
                        window.location.href = redirectUrl;
                    }, 100);

                    localStorage.clear();


                    return Promise.reject({
                        status: 401,
                        statusText: 'ERROR',
                        message: 'Session timed out.'
                    });
                });

                // alert('For your security, your session has timed out due to inactivity.. Please login again.');
                // window.location.href = '/admin';

                // if validation error
            }  else if(error.response.status === 422) {
                counter = 0;
                
                return Promise.reject({
                    'status': 422, 
                    'statusText': 'ERROR',
                    'message': 'One of the required information is not added. Please make sure all required field(s) has been entered.'
                });

            } else {
                counter = 0;
                return Promise.reject({
                    'status': 503, 'statusText': 'ERROR',
                    'message': 'The requested server is unavailable.!'
                });
            }
        }

        //Re-Process only get request
        else if (error.response.status === 429 && error.response.config.method === 'get') {

            if (counter == 0) return axiosInstance.request(error.config);

            else counter = 0

        } else if (error.response.status === 401) {
            // return axiosInstance.request(error.config);

            // TODO:: set message and remove local storage item window.location to home page

            // window.location('')

            // naviagte() useNavigation() hooks
            // localStorage.clear()

            return Promise.reject({ 'status': 401, 'statusText': 'ERROR', 'message': 'Unauthorized Access.' });
        }

        /* if (error.response.status === 401 && originalRequest.url ===
            'http://dummydomain.com/auth/token') { // Added this condition to avoid infinite loop 
            // Redirect to any unauthorised route to avoid infinite loop...
            return Promise.reject(error);
        } */

        return Promise.reject(error);
    });


export default axiosInstance;